import React from "react";
import { EventTag } from "../../../models/EventTag";
import { TableCell, TableRow } from "../../../design/table";
import EventTagBadge from "../../../components/EventTagBadge";

interface EventTagListItemProps {
  eventTag: EventTag;
}

const EventTagListItem: React.FC<EventTagListItemProps> = ({
  eventTag,
}) => {
  return (
    <TableRow>
      <TableCell>
        <EventTagBadge eventTagId={eventTag._id} eventTags={[eventTag]} />
      </TableCell>
    </TableRow>
  );
};

export default EventTagListItem;
